export const countryCodes = [
  { abbreviation: "SG", code: "65" }, // Singapore
  { abbreviation: "US", code: "1" }, // United
  { abbreviation: "RU", code: "7" }, // Russia
  { abbreviation: "EG", code: "20" }, // Egypt
  { abbreviation: "ZA", code: "27" }, // South Africa
  { abbreviation: "GR", code: "30" }, // Greece
  { abbreviation: "NL", code: "31" }, // Netherlands
  { abbreviation: "BE", code: "32" }, // Belgium
  { abbreviation: "FR", code: "33" }, // France
  { abbreviation: "ES", code: "34" }, // Spain
  { abbreviation: "HU", code: "36" }, // Hungary
  { abbreviation: "IT", code: "39" }, // Italy
  { abbreviation: "RO", code: "40" }, // Romania
  { abbreviation: "CH", code: "41" }, // Switzerland
  { abbreviation: "AT", code: "43" }, // Austria
  { abbreviation: "GB", code: "44" }, // United Kingdom
  { abbreviation: "DK", code: "45" }, // Denmark
  { abbreviation: "SE", code: "46" }, // Sweden
  { abbreviation: "NO", code: "47" }, // Norway
  { abbreviation: "PL", code: "48" }, // Poland
  { abbreviation: "DE", code: "49" }, // Germany
  { abbreviation: "PE", code: "51" }, // Peru
  { abbreviation: "MX", code: "52" }, // Mexico
  { abbreviation: "CU", code: "53" }, // Cuba
  { abbreviation: "AR", code: "54" }, // Argentina
  { abbreviation: "BR", code: "55" }, // Brazil
  { abbreviation: "CL", code: "56" }, // Chile
  { abbreviation: "CO", code: "57" }, // Colombia
  { abbreviation: "VE", code: "58" }, // Venezuela
  { abbreviation: "MY", code: "60" }, // Malaysia
  { abbreviation: "AU", code: "61" }, // Australia
  { abbreviation: "ID", code: "62" }, // Indonesia
  { abbreviation: "PH", code: "63" }, // Philippines
  { abbreviation: "NZ", code: "64" }, // New Zealand
  { abbreviation: "TH", code: "66" }, // Thailand
  { abbreviation: "JP", code: "81" }, // Japan
  { abbreviation: "KR", code: "82" }, // South Korea
  { abbreviation: "VN", code: "84" }, // Vietnam
  { abbreviation: "CN", code: "86" }, // China
  { abbreviation: "TR", code: "90" }, // Turkey
  { abbreviation: "IN", code: "91" }, // India
  { abbreviation: "PK", code: "92" }, // Pakistan
  { abbreviation: "AF", code: "93" }, // Afghanistan
  { abbreviation: "LK", code: "94" }, // Sri Lanka
  { abbreviation: "MM", code: "95" }, // Myanmar
  { abbreviation: "IR", code: "98" }, // Iran
  { abbreviation: "MA", code: "212" }, // Morocco
  { abbreviation: "DZ", code: "213" }, // Algeria
  { abbreviation: "TN", code: "216" }, // Tunisia
  { abbreviation: "LY", code: "218" }, // Libya
  { abbreviation: "GM", code: "220" }, // Gambia
  { abbreviation: "SN", code: "221" }, // Senegal
  { abbreviation: "MR", code: "222" }, // Mauritania
  { abbreviation: "ML", code: "223" }, // Mali
  { abbreviation: "GN", code: "224" }, // Guinea
  { abbreviation: "CI", code: "225" }, // Ivory Coast
  { abbreviation: "BF", code: "226" }, // Burkina Faso
  { abbreviation: "NE", code: "227" }, // Niger
  { abbreviation: "TG", code: "228" }, // Togo
  { abbreviation: "BJ", code: "229" }, // Benin
  { abbreviation: "MU", code: "230" }, // Mauritius
  { abbreviation: "LR", code: "231" }, // Liberia
  { abbreviation: "SL", code: "232" }, // Sierra Leone
  { abbreviation: "GH", code: "233" }, // Ghana
  { abbreviation: "NG", code: "234" }, // Nigeria
  { abbreviation: "TD", code: "235" }, // Chad
  { abbreviation: "CF", code: "236" }, // Central African Republic
  { abbreviation: "CM", code: "237" }, // Cameroon
  { abbreviation: "CV", code: "238" }, // Cape Verde
  { abbreviation: "ST", code: "239" }, // Sao Tome and Principe
  { abbreviation: "GQ", code: "240" }, // Equatorial Guinea
  { abbreviation: "GA", code: "241" }, // Gabon
  { abbreviation: "CG", code: "242" }, // Congo
  { abbreviation: "CD", code: "243" }, // Democratic Republic of the Congo
  { abbreviation: "AO", code: "244" }, // Angola
  { abbreviation: "GW", code: "245" }, // Guinea-Bissau
  { abbreviation: "IO", code: "246" }, // British Indian Ocean Territory
  { abbreviation: "SC", code: "248" }, // Seychelles
  { abbreviation: "SD", code: "249" }, // Sudan
  { abbreviation: "RW", code: "250" }, // Rwanda
  { abbreviation: "ET", code: "251" }, // Ethiopia
  { abbreviation: "SO", code: "252" }, // Somalia
  { abbreviation: "DJ", code: "253" }, // Djibouti
  { abbreviation: "KE", code: "254" }, // Kenya
  { abbreviation: "TZ", code: "255" }, // Tanzania
  { abbreviation: "UG", code: "256" }, // Uganda
  { abbreviation: "BI", code: "257" }, // Burundi
  { abbreviation: "MZ", code: "258" }, // Mozambique
  { abbreviation: "ZM", code: "260" }, // Zambia
  { abbreviation: "MG", code: "261" }, // Madagascar
  { abbreviation: "RE", code: "262" }, // Reunion and Mayotte
  { abbreviation: "ZW", code: "263" }, // Zimbabwe
  { abbreviation: "NA", code: "264" }, // Namibia
  { abbreviation: "MW", code: "265" }, // Malawi
  { abbreviation: "LS", code: "266" }, // Lesotho
  { abbreviation: "BW", code: "267" }, // Botswana
  { abbreviation: "SZ", code: "268" }, // Eswatini
  { abbreviation: "KM", code: "269" }, // Comoros and Mayotte
];
